<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div class="ml5">
          企业
          <a-select class="select-narrow ml24" placeholder="请选择" v-model:value="query.providerCode">
            <a-select-option v-for="option in providerList" :key="option.value" :value="option.code">
              {{ option.name }}
            </a-select-option>
          </a-select>
        </div>
        <div class="ml30">
          姓名/电话
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.sk"></a-input>
        </div>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <!-- 右侧按钮区域可以根据需要添加 -->
      </div>
    </div>
    <a-table :columns="columns" :row-key="(record) => record.id"
             size="middle" class="mt23" :scroll="{ x: 1500, y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }"
             :data-source="dataSource"
             :pagination="pagination">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'ranking'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'gender'">
          {{ record.gender === 0 ? '女' : '男' }}
        </template>
        <template v-if="column.key === 'status'">
          <span :class="record.status === 1 ? 'status-normal' : 'status-disabled'">
            {{ record.status === 1 ? '正常' : '停用' }}
          </span>
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a @click="detail(record)">详情</a>
          </span>
        </template>
      </template>
    </a-table>

    <!-- 安全员详情弹框 -->
    <DetailModal v-model:open="detailVisible" :security-user-id="detailId" />
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { getSecurityUserPageList } from "@/api/securityUser/securityUser";
import { getProviderList } from "@/api/settings/provider";
import useUserStore from '@/store/modules/user';
import DetailModal from '@/views/securityUser/components/DetailModal.vue';

const router = useRouter();
const store = useUserStore();

const columns = [
  {
    title: "序号",
    key: "ranking",
    width: 60,
  },
  {
    title: "所属企业",
    dataIndex: "deptName",
    key: "deptName",
    width: 200,
  },
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
    width: 100,
  },
  {
    title: "手机号码",
    key: "phone",
    dataIndex: "phone",
    width: 150,
  },
  {
    title: "身份证号",
    key: "idCard",
    dataIndex: "idCard",
    width: 200,
  },
  {
    title: "性别",
    key: "gender",
    dataIndex: "gender",
    width: 80,
  },
  {
    title: "培训日期",
    key: "trainingDate",
    dataIndex: "trainingDate",
    width: 120,
  },
  {
    title: "状态",
    key: "status",
    dataIndex: "status",
    width: 80,
  },
  {
    title: "创建时间",
    key: "createTime",
    dataIndex: "createTime",
    width: 160,
  },
  {
    title: "操作",
    key: "action",
    fixed: 'right',
    width: 120,
  },
];

let dataSource = ref([]);
let providerList = ref([]);

// 详情弹框
const detailVisible = ref(false);
const detailId = ref(null);

let query = reactive({
  providerCode: "",
  sk: ""
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 20,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
  pagination.current = page;
  getData();
}

function pageSizeChange(current, size) {
  pagination.pageSize = size;
  getData();
}

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.providerCode = "";
  query.sk = "";
  pagination.current = 1;
  getData();
};

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, deptIdStr: store.deptId },
  };
  getSecurityUserPageList(data).then((res) => {
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

onMounted(async () => {
  getProviderList().then(res => {
    if (res.code === 200 && res.data) {
      providerList.value = res.data;
    }
  });
  getData();
});

const detail = (record) => {
  detailId.value = record.id;
  detailVisible.value = true;
};

</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.select-narrow {
  width: 8vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767E;
}

/deep/.ant-select-selector {
  background-color: #F2F4F7 !important;
  color: #68767E !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}

.status-normal {
  color: #52c41a;
  font-size: 13px;
}

.status-disabled {
  color: #999;
  font-size: 13px;
}
</style>